import script from "./BuyRight.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyRight.vue?vue&type=script&setup=true&lang=js"

import "./BuyRight.vue?vue&type=style&index=0&id=2b4d7052&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b4d7052"]])

export default __exports__